<div class="p-4">
  <h6 class="m-3">Choose from the following and submit your vote</h6>

  <button id="modal-close-icon" class="absolute right-4 top-4" (click)="close()">
    <span class="text-lg material-symbols-rounded text-grey-800">close</span>
  </button>
  <mat-divider class="m-3 border-gray-300"></mat-divider>

  <form [formGroup]="voteOptionForm">
    <div
      class="flex items-stretch justify-between w-full gap-2 p-4 text-gray-700 children:w-1/2 children:flex-1 children:children:h-full body-default-regular">

      <div class="p-4 border border-gray-400 rounded-md"
        [ngClass]="{'border-blue-400 bg-blue-50 text-black' : agreeSelect?.value}">
        <div class="flex flex-col ">

          <div class="flex justify-between mb-4">
            <div class="flex font-bold">
              <div class="mr-2">{{agree.text}}</div>
              <div class="material-symbols-rounded" [ngStyle]="{'color': agree.color}">{{agree.icon}}</div>
            </div>
            <div>
              <label for="agreeBtn" class="flex items-center cursor-pointer">
                <span class="mr-2">Select</span>
                <input type="checkbox" id="agreeBtn" name="agreeSelectCtrl" (click)="selectAgree()"
                  formControlName="agreeSelectCtrl" class="mr-1" />
              </label>
            </div>
          </div>

          <div class="mt-2" [ngClass]="{'pointer-events-none': !agreeSelect?.value}">
            <p>{{noteTitle}}</p>
            <app-text-area id="agree-note" formControlName="agreeNoteCtrl" [displayCharactersCount]="false"
              placeholder={{noteTitle}}></app-text-area>
          </div>

        </div>
      </div>

      <div class="p-4 border border-gray-400 rounded-md"
        [ngClass]="{'border-blue-400 bg-blue-50 text-black' : disagreeSelect?.value}">
        <div class="flex flex-col ">

          <div class="flex justify-between mb-4">
            <div class="flex font-bold">
              <div class="mr-2">{{disagree.text}}</div>
              <div class="material-symbols-rounded" [ngStyle]="{'color': disagree.color}">{{disagree.icon}}</div>
            </div>
            <div>
              <label for="disagreeBtn" class="flex items-center cursor-pointer">
                <span class="mr-2">Select</span>
                <input type="checkbox" id="disagreeBtn" name="disagreeSelectCtrl" (click)="selectDisagree()"
                  formControlName="disagreeSelectCtrl" class="mr-1" />
              </label>
            </div>
          </div>


          <div class="mt-2" [ngClass]="{'pointer-events-none': !disagreeSelect?.value}">
            <p>{{noteTitle}}<span class="ml-2 text-red-500">*</span></p>
            <app-text-area id="disagree-note" formControlName="disagreeNoteCtrl" [displayCharactersCount]="false"
              placeholder={{noteTitle}}></app-text-area>
          </div>

        </div>
      </div>

    </div>

    @if (isCoaManagedBySf === false) {
    <div class="items-stretch p-4 m-4 border border-gray-400 rounded-md"
      [ngClass]="{'border-blue-400 bg-blue-50 text-black' : certificateOfAppreciation?.value}">
      <div class="flex flex-col ">
        <div class="flex justify-between mb-4">
          <div class="flex font-bold">
            <div class="mr-2">Certificate of Appreciation</div>
          </div>
          <div class="flex flex-row ">
            <div class="mr-4">
              <label for="coaSelectionBtn" class="flex items-center mr-4 cursor-pointer">
                <input type="radio" id="coaSelectionBtn" name="certificateOfAppreciationCtrl" value="yes"
                  formControlName="certificateOfAppreciationCtrl" class="mr-1" checked />
                Yes
              </label>
            </div>
            <div>
              <label for="coaSelectionBtn" class="flex items-center mr-4 cursor-pointer">
                <input type="radio" id="coaSelectionBtn" name="certificateOfAppreciationCtrl" value="no"
                  formControlName="certificateOfAppreciationCtrl" class="mr-1" />
                No
              </label>
            </div>
          </div>
        </div>

        <mat-divider class="border-gray-300 "></mat-divider>

        <div class="h-3/4">
          <div class="mt-4">
            <p>
              I wish to receive a Certificate of Appreciation and a printed copy of the final publication. Please send
              this to my postal address <span class="text-red-600">{{userAddress}}.</span>
            </p>

            <!-- External NON-Okta users -->
            <p *ngIf="isExternalNonOktaUser">
              Please note: If this is not the correct address, please go to the <a *ngIf="appUrls" mat-menu-item
                class="text-blue-500" href="{{ appUrls.iamProfileUrl }}" target="_blank"
                id="a-user-menu-option-profile-link">
                My Profile
              </a> page and update your details.
            </p>

            <!-- External Okta users -->
            <p *ngIf="isExternalOktaUser">
              Please note: If the address shown is incorrect, please contact our
              <a class="text-blue-500" href="mailto:Committee.Records@standards.org.au"
                id="a-user-committee-records-team-link">
                Committee Records team
              </a>
              to update your details and ensure you receive your items.
            </p>
          </div>

        </div>

      </div>

    </div>
    }
    @else if (isCoaManagedBySf === true) {
    <div class="p-4 body-small-regular text-subtle">
      After publication, you will receive an email with the option to request a printed hardcopy of the Certificate of
      Appreciation and the final publication.
    </div>
    }
  </form>
  <mat-divider class="m-4 border-gray-300"></mat-divider>


  <div class="flex justify-end gap-6 mt-5 mb-5 mr-4">
    <button class="px-8 py-3 border border-black btn btn-neutral" id="sd-vote-Cancel-Button" (click)="close()"
      type="button">Cancel</button>
    <button class="px-8 py-3 btn btn-primary" id="sd-place-vote-Button" [disabled]="!isFormValid"
      (click)="placeVote()">Submit</button>
  </div>
</div>